import { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useNavigation } from '@hotjar/navigation/src/hooks/useNavigation';
import { SETTINGS } from '@hotjar/webapp/constants/routes';

import { getTokensWithCode, storeIntegration } from '../../domains/hubspot/api';

export const HubspotOAuth = (): null => {
  const [searchParams] = useSearchParams();
  const { buildHrefFromRoute } = useNavigation();
  const navigate = useNavigate();

  const activateHubspot = useCallback(async () => {
    const error = searchParams.get('error');
    const siteId = searchParams.get('state');
    const code = searchParams.get('code');
    const hubspotPageUrl = buildHrefFromRoute(SETTINGS.INTEGRATION_DETAILS.path, {
      siteId: String(siteId),
      integrationName: 'hubspot',
    });

    if (!code || !siteId || !hubspotPageUrl) {
      return;
    }

    if (error) {
      navigate(`${hubspotPageUrl}?oauth-success=false`);
    }

    try {
      const { data } = await getTokensWithCode(siteId, code);
      await storeIntegration(siteId, data.access_token, data.refresh_token);
      navigate(`${hubspotPageUrl}?oauth-success=true`);
    } catch {
      navigate(`${hubspotPageUrl}?oauth-success=false`);
    }
  }, [buildHrefFromRoute, navigate, searchParams]);

  useEffect(() => {
    activateHubspot();
  }, [activateHubspot]);

  return null;
};
